import * as React from "react";
import { forwardRef } from "react";
const SvgYellowRightArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8.00008 2.66797L7.06008 3.60797L10.7801 7.33464H2.66675V8.66797H10.7801L7.06008 12.3946L8.00008 13.3346L13.3334 8.0013L8.00008 2.66797Z", fill: "#F9CB37" }));
const ForwardRef = forwardRef(SvgYellowRightArrow);
export { ForwardRef as ReactComponent };
